var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlourish(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    overflow: "visible",
    preserveAspectRatio: "none",
    viewBox: "0 0 423.5400085449219 430.70001220703125",
    id: "Layer_2_1707942095841",
    width: 120,
    height: 122,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1, 1)"
  }, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1_1707942095841 {\n        fill: #fff0d7;\n        stroke-width: 0px;\n      }\n    "))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2_1707942095841"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M210.76,428.7c116.22,0,210.78-96.16,210.78-214.35S326.98,0,210.76,0c-56.31,0-109.24,22.3-149.05,62.8C21.92,103.29,0,157.11,0,214.35c0,118.19,94.55,214.35,210.76,214.35ZM210.76,7.04c112.34,0,203.74,93,203.74,207.31s-91.4,207.31-203.74,207.31S7.04,328.66,7.04,214.35,98.43,7.04,210.76,7.04Z",
    className: "cls-1_1707942095841",
    vectorEffect: "non-scaling-stroke",
    style: {
      fill: "rgb(191, 165, 152)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.29,198.48c-7.1,6.58-14.99,11.96-23.47,15.89,8.47,3.9,16.36,9.28,23.47,15.86-1.33,7.68-3.61,15.22-6.88,22.43,6.7-3.03,13.7-5.22,20.81-6.58,7.47,10.4,13.45,22.48,17.51,35.72,4.06-13.23,10.04-25.29,17.51-35.69,7.17,1.38,14.21,3.6,20.96,6.67-3.3-7.26-5.61-14.86-6.95-22.59,7.11-6.57,15-11.93,23.47-15.83-8.48-3.92-16.38-9.3-23.5-15.89,1.32-7.71,3.61-15.28,6.88-22.52-6.73,3.04-13.74,5.24-20.88,6.6-7.47-10.4-13.44-22.45-17.49-35.67-4.05,13.22-10.01,25.26-17.46,35.65-7.16-1.37-14.19-3.58-20.94-6.63,3.3,7.25,5.61,14.84,6.95,22.56Z",
    className: "cls-1_1707942095841",
    vectorEffect: "non-scaling-stroke",
    style: {
      fill: "rgb(191, 165, 152)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.77,140.04c5.58,0,10.11-4.52,10.11-10.11s-4.52-10.11-10.11-10.11-10.11,4.52-10.11,10.11,4.52,10.11,10.11,10.11Z",
    className: "cls-1_1707942095841",
    vectorEffect: "non-scaling-stroke",
    style: {
      fill: "rgb(191, 165, 152)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.77,113.05c3.31,0,6-2.69,6-6s-2.69-6-6-6-6,2.69-6,6,2.69,6,6,6Z",
    className: "cls-1_1707942095841",
    vectorEffect: "non-scaling-stroke",
    style: {
      fill: "rgb(191, 165, 152)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.77,95.67c.78,0,1.41-.63,1.41-1.41v-58.44c0-.78-.63-1.41-1.41-1.41s-1.41.63-1.41,1.41v58.44c0,.78.63,1.41,1.41,1.41Z",
    className: "cls-1_1707942095841",
    vectorEffect: "non-scaling-stroke",
    style: {
      fill: "rgb(191, 165, 152)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.77,288.67c-5.58,0-10.11,4.52-10.11,10.11s4.52,10.11,10.11,10.11,10.11-4.52,10.11-10.11-4.52-10.11-10.11-10.11Z",
    className: "cls-1_1707942095841",
    vectorEffect: "non-scaling-stroke",
    style: {
      fill: "rgb(191, 165, 152)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.78,315.66c-3.31,0-6,2.69-6,6s2.69,6,6,6,6-2.69,6-6-2.69-6-6-6Z",
    className: "cls-1_1707942095841",
    vectorEffect: "non-scaling-stroke",
    style: {
      fill: "rgb(191, 165, 152)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.77,333.03c-.78,0-1.41.63-1.41,1.41v58.44c0,.78.63,1.41,1.41,1.41s1.41-.63,1.41-1.41v-58.44c0-.78-.63-1.41-1.41-1.41Z",
    className: "cls-1_1707942095841",
    vectorEffect: "non-scaling-stroke",
    style: {
      fill: "rgb(191, 165, 152)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.19,224.46c5.58,0,10.11-4.52,10.11-10.11s-4.52-10.11-10.11-10.11-10.11,4.52-10.11,10.11,4.52,10.11,10.11,10.11Z",
    className: "cls-1_1707942095841",
    vectorEffect: "non-scaling-stroke",
    style: {
      fill: "rgb(191, 165, 152)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.07,220.35c3.31,0,6-2.69,6-6s-2.69-6-6-6-6,2.69-6,6,2.69,6,6,6Z",
    className: "cls-1_1707942095841",
    vectorEffect: "non-scaling-stroke",
    style: {
      fill: "rgb(191, 165, 152)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.86,215.76h58.44c.78,0,1.41-.63,1.41-1.41s-.63-1.41-1.41-1.41h-58.44c-.78,0-1.41.63-1.41,1.41s.63,1.41,1.41,1.41Z",
    className: "cls-1_1707942095841",
    vectorEffect: "non-scaling-stroke",
    style: {
      fill: "rgb(191, 165, 152)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.35,224.46c5.58,0,10.11-4.52,10.11-10.11s-4.52-10.11-10.11-10.11-10.11,4.52-10.11,10.11,4.52,10.11,10.11,10.11Z",
    className: "cls-1_1707942095841",
    vectorEffect: "non-scaling-stroke",
    style: {
      fill: "rgb(191, 165, 152)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.46,220.36c3.32,0,6-2.69,6-6s-2.69-6-6-6-6,2.69-6,6,2.69,6,6,6Z",
    className: "cls-1_1707942095841",
    vectorEffect: "non-scaling-stroke",
    style: {
      fill: "rgb(191, 165, 152)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.09,214.35c0-.78-.63-1.41-1.41-1.41h-58.44c-.78,0-1.41.63-1.41,1.41s.63,1.41,1.41,1.41h58.44c.78,0,1.41-.63,1.41-1.41Z",
    className: "cls-1_1707942095841",
    vectorEffect: "non-scaling-stroke",
    style: {
      fill: "rgb(191, 165, 152)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.61,161.81c3.95-3.95,3.95-10.34,0-14.29-3.95-3.95-10.34-3.95-14.29,0-3.95,3.95-3.95,10.34,0,14.29,3.95,3.95,10.35,3.95,14.29,0Z",
    className: "cls-1_1707942095841",
    vectorEffect: "non-scaling-stroke",
    style: {
      fill: "rgb(191, 165, 152)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.93,266.91c-3.95,3.95-3.95,10.34,0,14.29,3.95,3.95,10.34,3.95,14.29,0,3.95-3.95,3.95-10.34,0-14.29-3.95-3.95-10.34-3.95-14.29,0Z",
    className: "cls-1_1707942095841",
    vectorEffect: "non-scaling-stroke",
    style: {
      fill: "rgb(191, 165, 152)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    r: 10.11,
    cy: 274.05,
    cx: 270.46,
    className: "cls-1_1707942095841",
    vectorEffect: "non-scaling-stroke",
    style: {
      fill: "rgb(191, 165, 152)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.22,161.81c3.95-3.95,3.95-10.34,0-14.29-3.95-3.95-10.35-3.95-14.29,0-3.95,3.95-3.95,10.34,0,14.29,3.95,3.95,10.34,3.95,14.29,0Z",
    className: "cls-1_1707942095841",
    vectorEffect: "non-scaling-stroke",
    style: {
      fill: "rgb(191, 165, 152)"
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlourish);
export default __webpack_public_path__ + "static/media/flourish.a60180bd4ca91716c82327c57114b273.svg";
export { ForwardRef as ReactComponent };